import React from "react";

const Footer = () => {
    return (
        <footer className="footer-area p-3">
            <div className="container-fluid px-0">
                <div className="d-flex justify-content-end pe-2">
                    <div className="text-end">
                        <p className="mb-1">Derechos reservados © 2025 Serjus</p>
                        <p className="mb-0">
                            Desarrollado por Miguel Alonzo, Melany Ambrocio, Jose Serra y Sebastian Pereira
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
